import React, { useState, useEffect } from 'react';
import { PageHeader } from '../components/ui/bootstrap';
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Upload } from 'lucide-react';
import Content from "./Content"
import UploadAudio from '../components/UploadAudio';

function ContentAudioArticle(){
    const { org_id, id } = useParams();
    const history = useHistory();
    const location = useLocation();
    const [selectedAudio, setSelectedAudio] = useState(null);
    const [showUploadAudio, setShowUploadAudio] = useState(false);

    useEffect(() => {
        if (new URLSearchParams(location.search).get('upload')) {
            setShowUploadAudio(true);
            history.replace({ search: '' });
        }
    }, [location.search, history]);

    return(
        <React.Fragment>
            <PageHeader
                title="Audio Articles"
                subtitle="Manage and publish audio versions of your articles"
                right={
                    <button
                        onClick={() => setShowUploadAudio(true)}
                        className="btn d-flex align-items-center gap-2 fw-semibold"
                        style={{
                            background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-secondary) 100%)',
                            color: 'white',
                            borderRadius: 50,
                            fontSize: 13,
                            padding: '8px 20px',
                            border: 'none',
                        }}
                    >
                        <Upload size={16} />
                        Upload Audio
                    </button>
                }
            />

            <UploadAudio
                orgId={org_id}
                integrationId={id}
                show={showUploadAudio}
                selectedAudio={selectedAudio}
                onSuccess={() => {
                    setSelectedAudio(null);
                    window.location.reload();
                }}
                onHide={() => {
                    setShowUploadAudio(false);
                    setSelectedAudio(null);
                }}
            />

            <Content
                contentType="audio_article"
                setSelectedAudio={(val) => setSelectedAudio(val)}
                setShowUploadAudio={(val) => setShowUploadAudio(val)}
            />
        </React.Fragment>
    );
}

export default ContentAudioArticle;
